import React from 'react';

import {dataTypeString} from 'src/components/data-types/utils/dataTypeString';
import {FieldType} from 'src/openapi/models/FieldType';
import {ItemsType} from 'src/openapi/models/ItemsType';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

type Props = {
    dataType: FieldType,
    itemsType?: ItemsType,
};

export const DataType = ({dataType, itemsType}: Props) => {
    return (
        <EllipsisTextHint isActive={false} mix="data-types">
            {dataTypeString(dataType, itemsType)}
        </EllipsisTextHint>
    );
};
